import { render, staticRenderFns } from "./StoreDetailsModal.vue?vue&type=template&id=17980d68&scoped=true"
import script from "./StoreDetailsModal.vue?vue&type=script&lang=js"
export * from "./StoreDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./StoreDetailsModal.vue?vue&type=style&index=0&id=17980d68&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17980d68",
  null
  
)

export default component.exports